// @ts-nocheck


import notification from 'antd/lib/notification';
import React, { Component } from 'react';
import styled from 'styled-components';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { Icon } from '../../../../components/ui';

import { Card, Spinner } from './../../../../components';
import { Option, Select } from './../../../../components/ant/Select';

import InstallEquipmentButton from './../InstallEquipmentButton';

const { Field } = Card;

const Wrapper = styled.div`
  padding: 16px;
`;
const AddButton = styled.span`
  cursor: pointer;
  color: #2770ff;
  display: flex;
  & .icon {
    margin-right: 5px;
  }
`;














class AttachedEquipmentForm extends Component {
  static defaultProps = {
    availableEquipments: []
  };
  state = {
    currentAttachedEquipmentId: null,
    visibleForm: false
  };

  onAttachedEquipmentSelect = (currentAttachedEquipmentId) =>
  this.setState({
    currentAttachedEquipmentId
  });

  onAddClick = async (installDate) => {
    const { currentAttachedEquipmentId } = this.state;
    const { availableEquipments } = this.props;
    const attachedEquipment = availableEquipments.find(
      (item) => item.id === currentAttachedEquipmentId
    );
    if (attachedEquipment) {
      await this.props.onSubmit({ ...attachedEquipment, installDate });
      this.setState({
        currentAttachedEquipmentId: null,
        visibleForm: false
      });
    } else {
      notification.error({
        message: 'Необходимо выбрать навесное оборудование из списка'
      });
    }
  };

  handleAddButtonClick = () => {
    this.setState({ visibleForm: true });
  };

  render() {
    const { currentAttachedEquipmentId, visibleForm } = this.state;
    const {
      availableEquipments,
      handleSearch,
      fetchData,
      isLoading
    } = this.props;
    return (
      <Wrapper>
        {visibleForm ?
        <Grid gutter="16px">
            <GridItem>
              <Field label="Оборудование">
                <Select
                placeholder="Выберите оборудование"
                value={currentAttachedEquipmentId}
                onChange={this.onAttachedEquipmentSelect}
                showSearch
                onSearch={handleSearch}
                filterOption={false}
                defaultActiveFirstOption={false}
                onBlur={() => fetchData()}
                notFoundContent={
                <Spinner
                  isLoading={isLoading}
                  notFoundText="Оборудование не найдено" />

                }>

                  {availableEquipments.map((equipment) =>
                <Option key={equipment.id} value={equipment.id}>{`${
                  equipment.name} ${
                  equipment.brandName}`}</Option>
                )}
                </Select>
              </Field>
            </GridItem>
            <GridItem fullWidth>
              <InstallEquipmentButton
              onConfirm={this.onAddClick}
              disabled={!currentAttachedEquipmentId} />

            </GridItem>
          </Grid> :

        <AddButton onClick={this.handleAddButtonClick}>
            <Icon type="plus" />
            Добавить навесное оборудование
          </AddButton>
        }
      </Wrapper>);

  }
}

export default AttachedEquipmentForm;
